angular.module('component-payments.format', [
	require('./cvc'),
	require('./expire'),
	require('./month'),
	require('./month-text'),
	require('./name'),
	require('./number'),
	require('./year'),
	require('./year-text')
]);

module.exports = 'component-payments.format';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/formatters/index.js
 ** module id = 90
 ** module chunks = 1
 **/